<template>
  <div class="PreviewWindowsFirefox" :class="{ 's-hasIcon': hasIcon }">
      <div class="Title" ref="title" v-html="base.titleSmall"></div>
      <div v-if="hasIcon" class="Icon" :style="{'backgroundImage': 'url(' + base.icon + ')'}"></div>
      <div class="Body" ref="body" v-html="base.body"></div>
      <div class="Info">{{$t('via')}} {{base.domain}}</div>
  </div>
</template>

<script>

// import lineClamp from 'line-clamp'

export default {
  name: 'PreviewWindowsFirefox',
  props: {
    base: Object,
    override: Object
  },
  data() {
    return {
    }
  },
  computed: {
    hasIcon() {
      return !!this.base.icon
    }
  },
  mounted() {
    // lineClamp(this.$refs.title, 1)
    // lineClamp(this.$refs.body, 5)
    // console.log(lineClamp, this.$refs.body)
  }
}
</script>

<style scoped lang="less">
  .PreviewWindowsFirefox {
    width: 350px;
    min-height: 70px;
    user-select: none;
    position: relative;
    border: 1px solid #dedede;
    font-family: 'Open Sans', sans-serif;
    box-shadow: 0px 0px 5px rgb(200, 200, 200);
    background-color: #fff;
    background: url('../assets/icon-windows-ff-close.png') right top no-repeat, url('../assets/icon-windows-ff-settings.png') right bottom no-repeat;
    &.s-hasIcon {
      min-height: 118px;
    }
  }
  .Icon {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 29px;
    left: 7px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .Title {
    font-size: 11px;
    width: 315px;
    font-weight: bold;
    margin-left: 9px;
    margin-top: 7px;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }
  .Body {
    color: #000;
    font-size: 11px;
    margin-top: 7px;
    margin-left: 9px;
    width: 315px;
    margin-bottom: 28px;

    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }
  .Info {
    margin-top: 2px;
    font-size: 9px;
    color: #7f7f7f;
    margin-left: 9px;
    margin-bottom: 12px;
    position: absolute;
    bottom: 0;
  }
  .s-hasIcon .Body, .s-hasIcon .Info {
    padding-left: 84px;
    width: 310px;
  }
</style>
